export function Footer(): JSX.Element {
  return (
    <footer className="py-6 bg-gray-200 text-gray-500 text-center">
      <div className="px-8 lg:px-32 flex justify-between items-center">
        <div 
          className="tracking-wide cursor-pointer"
          onClick={() => window.open('https://viewEngine.studio', '_blank')}
        >
          {/*Powered by: View<span className="text-black font-semibold">Engine</span>*/}
          <span className="text-gray-400">Powered by: </span>View<span className="text-black font-semibold">Engine</span>
        </div>
        <span 
          className="cursor-pointer"
          onClick={() => window.open('https://viewEngine.studio', '_blank')}
        >
          © 2025 ViewEngine
        </span>
      </div>
    </footer>
  );
}
